module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/file-5c65198d5298d7322f8b59f77aa43fe5.svg";